import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanySettingsService {

  private settings = new BehaviorSubject<any>(null);

  get settings$(): Observable<any> {
    return this.settings.asObservable();
  }

  updateSettings(data: any): void {
    this.settings.next(data);
  }

  getCurrentSettings(): any {
    return this.settings.getValue();
  }
}
